<script>
    import * as ze from "@axel669/zephyr"

    import { numericInput } from "./numeric.js"

    let {
        item = $bindable()
    } = $props()

    const weight = numericInput(item, "weight")
    const count = numericInput(item, "count")
</script>

<ze.Input type="text" label="Item Name" linedFill bind:value={item.name} />
<ze.Input type="number" label="Item Weight" linedFill bind:value={weight.get, weight.set} />
<ze.Input type="number" label="Count" linedFill bind:value={count.get, count.set} />
<ze.Input type="area" label="Bag Description" linedFill bind:value={item.info} h="7em" />
